import { Router as WouterRouter, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Home from "@/pages/home";
import NotFound from "@/pages/not-found";
import Chat from "@/pages/chat";
import CpuSizing from "@/pages/cpu-sizing";
import { useThemeStore } from "@/lib/themeStore";

// wouter's <Router base> wants "/llm-sizing-tool-fullscreen" (no trailing slash).
// BASE_URL comes from `base` in vite.config.ts, so this can't drift out of sync if
// the subpath ever changes. Without the base, useLocation() below reads the raw
// browser path (e.g. "/llm-sizing-tool-fullscreen/"), which matches neither "/" nor
// "/chat", so every route falls through to <NotFound />.
const routerBase = import.meta.env.BASE_URL.replace(/\/$/, "");

const KNOWN_ROUTES = ["/", "/chat", "/cpu-sizing"];

function Router() {
  const [location] = useLocation();
  return (
    <>
      <div style={{ display: location === "/" ? "block" : "none" }}>
        <Home />
      </div>
      <div style={{ display: location === "/chat" ? "block" : "none" }}>
        <Chat />
      </div>
      <div style={{ display: location === "/cpu-sizing" ? "block" : "none" }}>
        <CpuSizing />
      </div>
      {!KNOWN_ROUTES.includes(location) && <NotFound />}
    </>
  );
}

function App() {
  const { dark } = useThemeStore();

  return (
    <div className={dark ? "dark" : ""}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <WouterRouter base={routerBase}>
            <Toaster />
            <Router />
          </WouterRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
